import { render } from "./SolutionView.vue?vue&type=template&id=7cbb8bee"
import script from "./SolutionView.vue?vue&type=script&lang=js"
export * from "./SolutionView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__